export default "__VITE_ASSET__eb1eb199__"